import type { PropsWithChildren } from "react";
import { createContext } from "react";
import { AnimateModal } from "../animateModal";
import { useHandleAnimateModalState } from "../hooks/useAnimateModal";
import { type AnimateModalContextProps } from "../types";

export const AnimateModalContext = createContext<AnimateModalContextProps | undefined>(undefined);

export const AnimateModalProvider = ({ children }: PropsWithChildren) => {
    const value = useHandleAnimateModalState();
    const { isOpen, modalContent, closeModal } = value;

    return (
        <AnimateModalContext.Provider value={value}>
            {children}
            <AnimateModal onClose={closeModal} isOpen={isOpen}>
                {modalContent}
            </AnimateModal>
        </AnimateModalContext.Provider>
    );
};
